import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useToaster } from '@life_uikit/uikit';
import { setGlobalToastCallback } from '@/shared/api/error-handler';

// Инициализируем глобальный toast callback для error handler

export default /*@__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

const toast = useToaster();
setGlobalToastCallback((message, options) => {
  toast(message, { toast: { type: options?.type || 'info', duration: options?.duration || 3000 } });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})